export default __webpack_public_path__ + "static/media/footer3.e4862d9c.jpg";